import { render, staticRenderFns } from "./StudentTheoryList.vue?vue&type=template&id=6d59d3ac&scoped=true"
import script from "./StudentTheoryList.vue?vue&type=script&lang=js"
export * from "./StudentTheoryList.vue?vue&type=script&lang=js"
import style0 from "./StudentTheoryList.vue?vue&type=style&index=0&id=6d59d3ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d59d3ac",
  null
  
)

export default component.exports